module.exports = __webpack_public_path__ + "img/comms-workflow.165ec78b.png";